// extracted by mini-css-extract-plugin
export default {"container":"healthmonitoringbars_container__AIXxj","item_right":"healthmonitoringbars_item_right__qSrLt"};